import React from 'react';
import OnCallSchedule from '../OnCallSchedule.jsx';

/**
 * AdminOnCall — Wraps the existing OnCallSchedule page for admin use.
 */
const AdminOnCall = () => {
  return (
    <div className="py-6">
      <OnCallSchedule />
    </div>
  );
};

export default AdminOnCall;
